import { Box, Typography } from "@mui/material";

const Footer = () => {
    return (
    <>
        <Box sx={{ bgcolor: 'background.paper', p: 2, my: 4 }} component="footer">
        <Typography
            variant="subtitle1"
            align="center"
            color="text.primary"
            component="p"
        >
            Soluciones financieras a su medida!
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
                    {'Copyright © '}
                    {new Date().getFullYear()}
                    {'. LR'}
                </Typography>
        </Box>
    </>
    )
}

export default Footer;